export default {
	invalid_pixel_id: "Identificador de Pixel inválido",
	invalid_access_token: "Token de acesso inválido"
}
